import type { FC } from "react";
import { InnerCRUD } from "@/shared/components";
import {
  RevenueShareReportsListQuery,
  type RevenueShareReportsListRow,
} from "@/admin/entities/revenueShareReports";
import {
  getColumnsConfig,
  getTableData,
  getTextsConfig,
  mapColumns,
} from "./config";

interface OrganizationRevenueShareReportsProps {
  id?: string;
}

/**
 * Вкладка «Отчёты ревшера» у организации: по одному отчёту на месяц.
 * Создания нет, отчёты рождает дневная джоба; в строке доступны
 * корректировка и пересчёт черновика.
 */
export const OrganizationRevenueShareReports: FC<
  OrganizationRevenueShareReportsProps
> = ({ id }) => {
  return (
    <InnerCRUD<RevenueShareReportsListRow>
      listQuery={RevenueShareReportsListQuery}
      listQueryVariables={{ filter: { organizationId: id } }}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={getColumnsConfig()}
      texts={getTextsConfig()}
    />
  );
};
